import {
  MANAGE_ACCESS_PATH,
  SCREEN_COMPANIES_PATH,
  SCREEN_FUNDS_PATH,
} from '@upright/ui/common/generic/components/navigation/page-paths';
import { useIsClientOrTeamOrFreeTrial } from '@upright/ui/common/generic/hooks';
import styled from 'styled-components';
import { Item, ItemLink, MenuTitleSmall } from '../../shared-menus';

export const ToolsBlock = () => {
  const isClientOrTeam = useIsClientOrTeamOrFreeTrial();
  return (
    <Root>
      <MenuTitleSmall>Tools</MenuTitleSmall>

      <Item key={'screen-companies'}>
        <ItemLink to={SCREEN_COMPANIES_PATH}>Screen companies</ItemLink>
      </Item>
      <Item key={'screen-funds'}>
        <ItemLink to={SCREEN_FUNDS_PATH}>Screen funds</ItemLink>
      </Item>

      {isClientOrTeam ? (
        <Item key={'my-assets'}>
          <ItemLink to={MANAGE_ACCESS_PATH}>My assets</ItemLink>
        </Item>
      ) : (
        <Item key={'portfolio-builder'}>
          <ItemLink to={'/my-portfolios'}>Build a portfolio</ItemLink>
        </Item>
      )}
    </Root>
  );
};

const Root = styled.div``;
